import { Modal } from 'tailwindcss-stimulus-components'

export default class ModalController extends Modal {
  static targets = ['turboFrame', 'autofocus']

  open () {
    super.open()

    if (this.hasAutofocusTarget) {
      setTimeout(() => this.autofocusTarget.focus(), 100)
    }
  }

  close () {
    super.close()
    this.dispatch('close')

    if (this.hasTurboFrameTarget) {
      this.turboFrameTarget.src = null
      this.turboFrameTarget.innerHTML = ''
    }
  }
}
